<rcl-modal [show]="showGovernanceContent" (onClose)="closeModal()" [mobileFullScreen]="false">
  <rcl-modal-content class="governance-content-container">
    <rcl-modal-title>
      <a (click)="closeModal()" class="governance-content-close-container">
        <img inline-svg title="Close" [src]="'assets/icons/close-' + brandName + '.svg'" [alt]="'close' + brandName + ' icon'" />
      </a>
      <img inline-svg title="Warning" [src]="'assets/icons/triangle-warning-' + brandName + '.svg'" [alt]="'triangle warning ' + brandName + ' icon'" />
      <div class="governance-content-header">{{ bundle() && bundle()['label.safety.takeover.headline'] }}</div>
      <div class="governance-content-subheader">{{ bundle() && bundle()['label.safety.takeover.subcopy'] }}</div>
    </rcl-modal-title>
    <div class="governance-content-body">
      @for (protocol of protocols; track protocol) {
        <div class="governance-protocol-container">
          <img class="governance-protocol-icon" [src]="microservices.apiUrl + '/images' + protocol.icon" alt="Governance protocol icon" />
          <div class="governance-protocol-header">{{ protocol.heading }}</div>
          <div class="governance-protocol-body">{{ protocol.content }}</div>
        </div>
      }
    </div>
  </rcl-modal-content>
  <rcl-modal-actions class="governance-content-actions">
    <button class="rcl-button-secondary">
      {{ bundle() && bundle()['label.safety.takeover.questions'] }}
      <a [className]="'health-center-link-' + brandName" (click)="onVisitHealthCenter()">
        {{ bundle() && bundle()['label.safety.takeover.visit'] }}
        <img inline-svg title="Link" [src]="'assets/icons/chevron-right-' + brandName + '.svg'" [alt]="'chevron right ' + brandName + ' icon'" />
      </a>
    </button>
  </rcl-modal-actions>
</rcl-modal>
